const HEX_RE = /^#([0-9a-fA-F]{6})$/;

export const DEFAULT_LINK_COLORS = {
  button: '#2563eb',
  accent: '#2563eb',
};

const READY_PICKUP_LABEL = {
  curbside: 'Curbside',
  counter: 'Counter',
  bedside: 'Bedside',
  courier: 'Courier',
  kiosk: 'Locker',
  mail_order: 'Mail Order',
};

export const readyGreetingFor = (method) => {
  const label = READY_PICKUP_LABEL[method];
  if (!label) return 'we have you ready for pick up.';
  return `we have you ready for ${label} pick up.`;
};

const LEGACY_GREETINGS = {
  "we're preparing your order for pickup!": true,
  "we're preparing your order for delivery!": true,
  "we're preparing your order for mail delivery!": true,
  'a message from your pharmacy team': true,
};

export const isLegacyMobileGreeting = (value) =>
  !!LEGACY_GREETINGS[String(value || '').trim()];

export const DEFAULT_LINK_GREETING = readyGreetingFor('counter');
export const DEFAULT_LINK_ARRIVAL = 'I am here';
export const DEFAULT_LINK_HEADLINE = 'Complete Required Steps';
export const DEFAULT_LINK_INTRO =
  'Please complete all required steps below (payment, signature, ID capture, consultation) and click the "Checkout" button when you\'re ready. You\'ll receive your pickup QR code and detailed instructions on the next screen.';
export const DEFAULT_LINK_CTA = 'Pay Now';
export const LINK_CUSTOM_MESSAGE_MAX = 240;

const LEGACY_HEADLINES = {
  'Your order is ready': true,
  'Your curbside order is ready': true,
  'Your bedside order is ready': true,
  'Your order is on the way': true,
  'Your locker order is ready': true,
};

export const isLegacyLinkDraft = (htmlBody, headline) => {
  if (LEGACY_HEADLINES[String(headline || '').trim()]) {
    if (!htmlBody) return true;
    try {
      const parsed = JSON.parse(htmlBody);
      return !(parsed && parsed.v === 1);
    } catch (_err) {
      return true;
    }
  }
  return false;
};

export const normalizeLinkHex = (value, fallback) => {
  const raw = String(value || '').trim();
  if (HEX_RE.test(raw)) {
    return raw.toLowerCase();
  }
  if (/^[0-9a-fA-F]{6}$/.test(raw)) {
    return `#${raw.toLowerCase()}`;
  }
  return fallback;
};

export const parseMobileConfig = (htmlBody, method) => {
  let parsed = null;
  if (htmlBody) {
    try {
      parsed = JSON.parse(htmlBody);
    } catch (_err) {
      parsed = null;
    }
  }
  if (!parsed || parsed.v !== 1 || typeof parsed !== 'object') {
    parsed = {};
  }
  const defaultGreeting = readyGreetingFor(method);
  const rawGreeting = String(parsed.greeting || '').trim();
  const greeting =
    rawGreeting && !isLegacyMobileGreeting(rawGreeting)
      ? rawGreeting
      : defaultGreeting;
  return {
    greeting: greeting.slice(0, 80),
    custom_message: String(parsed.custom_message || '')
      .trim()
      .slice(0, LINK_CUSTOM_MESSAGE_MAX),
    arrival_label: String(parsed.arrival_label || DEFAULT_LINK_ARRIVAL).slice(
      0,
      40
    ),
    button_color: normalizeLinkHex(
      parsed.button_color,
      DEFAULT_LINK_COLORS.button
    ),
    accent_color: normalizeLinkHex(
      parsed.accent_color,
      DEFAULT_LINK_COLORS.accent
    ),
    hide_amount: !!parsed.hide_amount,
    logo_url: String(parsed.logo_url || '').trim(),
  };
};



// WEBPACK FOOTER //
// ./src/components/message-control-center/mobileConfig.js